export const PushAddToCart = (variant, quantity, currency) => {
    window.dataLayer.push({
        'event': 'add-to-cart',
        'item': {
            itemId: variant.id,
            itemName: variant.id,
            quantity: quantity,
            itemCategory: variant.category,
            price: Math.floor(variant.price / 100),
            priceCurrency: currency.toUpperCase()
        }
    })
}
export const PushCartViewed = (items, subtotalFormatted, totalFormatted, totalUK, currency, pathname) => {
    window.dataLayer.push({
        event: 'cart-viewed',
        page: {
            url: pathname,
            title: 'shopping-cart'
        },
        basket: {
            items: items.map(item => ({
                itemName: item.product,
                quantity: item.quantity,
                itemCategory: item.category,
                priceCurrency: currency
            })),
            subtotal: subtotalFormatted,
            total: totalFormatted,
            totalUK
        }
    });
}

export const PushContinueToShipping = (items, subtotalFormatted, totalFormatted, totalUK, currency) => {
    window.dataLayer.push({
        event: 'continue-to-shipping',
        basket: {
            items: items.map(item => ({
                itemName: item.product,
                quantity: item.quantity,
                itemCategory: item.category,
                priceCurrency: currency
            })),
            subtotal: subtotalFormatted,
            totalPrice: totalFormatted,
            totalUK
        }
    });
}

export const PushPurchase = (orderId, value, currency, items) => {
    window.dataLayer.push({
        event: 'purchase',
        transaction_id: orderId,
        value: value,
        currency: currency,
        items: items
    });
}